export * as Queries from './queries';
// export * as Mutations from './mutations'; // No mutations to export. Uncomment this line when adding a mutation.
export * as Types from './types';
export * from './service';

import { useSMSDataV4QueryUpdaters, Utils } from './query-updaters';
/**
 * Query updaters should only be used internally by mutations in an api library that affects v4 queries
 */
export const _QueryUpdaters = { useQueryUpdaters: useSMSDataV4QueryUpdaters, Utils };
